module.exports = __webpack_public_path__ + "img/31_29.c005f078.png";